import type { UpdateLegalDocumentDto } from '../dtos/update-legal-document.dto';
import type { UpdateAppContentUseCase } from './update-app-content.usecase';

export class UpdateTermsOfUseUseCase {
  constructor(private readonly updateAppContent: UpdateAppContentUseCase) {}

  execute(dto: UpdateLegalDocumentDto): Promise<void> {
    return this.updateAppContent.execute({ ...dto, key: 'termsOfUse' });
  }
}
